import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

//Projects
import ProjectsList from '../Projects/ProjectsList';
import { Layout } from 'rc-easyui';
import { Button, Icon } from 'semantic-ui-react';

import Spinner from '../common/Spinner';
import ProjectUtils from '../../helper/ProjectUtils';
import ApiUtils from '../../helper/ApiUtils';

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      listData: null,
      collapsed: true,
    };
    this.finishLoadData = this.finishLoadData.bind(this);
  }

  async componentDidMount() {
    try {
      await this.setState({ loading: true });
      const { user } = this.props.auth;

      //SubEdit/GetOrderDetial

      const email = user['email'];

      let projectListData = null;

      // 舊的方式
      // projectListData = await ProjectUtils.sentGetAllProjectDetial(
      //   user["unique_name"]
      // );

      const pCount = 30;
      await this.setState({ loading: true });
      let pList = []; // 基本專案列表
      if (email.includes('thesubpro.com') === true) {
        // projectListData = await ProjectUtils.sentGetAllProjectDetial(
        //   user["unique_name"]
        // );
        pList = await ApiUtils.post_sql(
          `${ApiUtils.get_GetProjectListlByCount}`,
          {
            listCount: parseFloat(pCount),
          }
        );

        // 透過基本列表來拉出詳細資料
        let resData = [];
        await pList.map(async (pObj, index) => {
          const pAllData = await ApiUtils.post_sql(
            `${ApiUtils.get_GetProjectDetialByPid}`,
            {
              projectDetialiD: pObj.fId,
            }
          );
          resData.push(pAllData);
          if (resData.length === pCount) {
            // Project  fId

            //排序
            resData.sort(function (a, b) {
              return b.Project.fId - a.Project.fId;
            });

            // 確認湊滿資料
            this.finishLoadData(resData);
          }
        });
      } else {
        projectListData = await ProjectUtils.sentGetProjectDetial(
          user['unique_name']
        );

        // 確認湊滿資料
        this.finishLoadData(projectListData);
      }
    } catch (error) {
      // alert(JSON.stringify(error))
      console.log(`signUser error ${error}`);
    }
  }

  /**
   * 結束拉取資料
   */
  async finishLoadData(projectListData) {
    if (projectListData !== null) {
      //有資料的話更新本地
      //儲存本地
      localStorage.setItem('projectListData', JSON.stringify(projectListData));

      await this.setState({ listData: projectListData });
    }

    // console.log(`有資料的話更新本地 ${JSON.stringify(projectListData)}`);

    await this.setState({ loading: false });
  }

  componentWillReceiveProps(nextProps) {}

  render() {
    const { listData, loading } = this.state;

    let mainView;
    if (listData === null || loading === true) {
      mainView = (
        <div className='pt-5  '>
          <Spinner />
        </div>
      );
    } else {
      mainView = (
        <Layout className='col-12 pt-5'>
          <ProjectsList listData={listData} />
        </Layout>
      );
    }

    return (
      <div className='position-relative' style={{ backgroundColor: '#dfdde0' }}>
        {mainView}

        <div
          className='position-absolute'
          style={{ top: '10px', left: '15px' }}
        >
          <Link to={`/editor`} target='_self'>
            <Button
              className='p-1'
              secondary
              icon
              labelPosition='left'
              onClick={() => {
                localStorage.removeItem('jwtToken');
                localStorage.removeItem('projectListData');
                localStorage.removeItem('playerEditingData');
              }}
            >
              <Icon name='angle double left' />
              Log out
            </Button>
          </Link>
        </div>
      </div>
    );
  }
}

Home.propTypes = {};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(withRouter(Home));



// WEBPACK FOOTER //
// ./src/components/layout/Home.js